// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"32":"b47532a3","321":"1354c866","804":"dfc48b2c"}[chunkId] + ".js";
};